

  <div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
    <div>
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


        <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

          <div class="row">
            <div class="col-md-1 padding-right-0px padding-left-6px" *ngIf="PatientDetails">
              <img class="img-circle-56 margin-left-10px" [src]="PatientDetails.PatientImageFile" onError="this.src='dummy.jpg';">
            </div>
            <div class="col-md-2 line-height-17px padding-left-0px padding-right-0px" *ngIf="PatientDetails">
              <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{PatientDetails.DisplayName}}</label>
              <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.FormattedCode}}</label></div>
              <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.Telephone1}}</label></div>
            </div>
            <!--<div class="col-md-3" *ngIf="PatientDetails">

            </div>-->
            <div class="col-md-7 line-height-17px">
              <!--<label class="margin-bottom-0px">{{ sectionData.Title }}</label>-->
              <label class="margin-bottom-0px font-weight-normal" *ngIf="TemplateName">{{TemplateName}}</label>
              <div><label class="margin-bottom-0px font-size-14 font-weight-normal" *ngIf="Date">{{Date|date:'dd-MM-yyyy'}}</label></div>
              <div class="row font-weight-700">
                <!--<div class="col-md-4">
      <label class="font-size-14 font-weight-normal margin-bottom-0px">Section Name</label>
    </div>:-->
                <div class="col-md-12  color-title padding-right-0px">
                  <label *ngIf="TitleName" class="font-size-16px font-weight-bold margin-bottom-0px  margin-top-3px">{{TitleName}}</label>

                </div>
              </div>
              <!--<div class="row font-weight-700">
    <div class="col-md-2">
      <label class="font-size-14 font-weight-normal margin-bottom-0px">Sign1</label>
    </div>:
    <div class="col-md-8 font-size-14 font-weight-normal">
      <label *ngIf="Sign1" class="font-size-14 font-weight-normal margin-bottom-0px">{{Sign1}}</label>

    </div>
  </div>
  <div class="row font-weight-700">
    <div class="col-md-2">
      <label class="font-size-14 font-weight-normal margin-bottom-0px"> Sign2 </label>
    </div>:
    <div class="col-md-8 font-size-14 font-weight-normal">

      <label *ngIf="Sign2" class="font-size-14 font-weight-normal margin-bottom-0px">{{Sign2}}</label>
    </div>
  </div>-->
            </div>

            
            <div class="col-md-2">

              <!--<button type="button" class="close float-right" data-dismiss="modal"
          (click)="activeModal.dismiss('Cross click')"
          aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>-->
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>

              <button (click)="onSubmit()" class="btn actions-btn-prime float-right font-size-15px ">Save</button>
            </div>
          </div>
          <!--{{ sectionData.Title }}-->


        </div>
        <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px">
          
          <div class="row">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive">


                  <table class="table table-striped margin-left-zero">

                    <thead class="">
                      <tr>
                        <th class="min-width-0px width-57px padding-top-4px padding-bottom-4px"></th>

                        <th class="width-53px padding-top-4px padding-bottom-4px">#</th>
                        <th class="width-178px padding-top-4px padding-bottom-4px">Title</th>
                        <th class="padding-top-4px padding-bottom-4px">Image</th>

                        <th class="padding-top-4px padding-bottom-4px">Comments</th>
                        <th class="padding-top-4px padding-bottom-4px"></th>
                      </tr>
                    </thead>
                    <tbody class="table-body">

                      <tr *ngFor="let field of sectionData.Fields; let RowIndex = index ">
                        <td class="padding-top-0px padding-bottom-0px ">

                          <input type="checkbox" [(ngModel)]="field.IsSelected" />
                          <i class="input-helper"></i>

                        </td>
                        <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>
                        <!--<td>{{field.Title}}</td>-->
                        <td class="padding-top-0px padding-bottom-0px ">   <input class="form-control " [(ngModel)]="field.Title" type="text" [ngModelOptions]="{standalone: true}" /></td>
                        <td class="padding-top-0px padding-bottom-0px padding-left-5px">
                          <!--<button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
    <i class="fas fa-ellipsis-h"></i>
  </button>-->
                          <div *ngIf="!field.HasImage">
                            <button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
                              <i class="fas fa-ellipsis-h"></i>
                            </button>
                          </div>
                          <div *ngIf="field.HasImage">
                            <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='dummy.jpg';" >
                            <button type="button" class="btn  btn-sm button-new-health margin-top-left" tooltip="Add" (click)="openDocContent(field)" *ngIf="field?.IsSelected"><i class="fas fa-plus nav-link-hand"></i></button>

                          </div>
                                                  </td>
                        <td class="padding-top-0px padding-bottom-0px">

                          {{field.Remarks}}

                        </td>


                        <td class="text-align-right padding-top-0px padding-bottom-0px">
                          <!--<button (click)="onSubmit()" class="button-service-save font-size-20px color-secondary nav-link-hand" title="Save" *ngIf="field?.IsSelected">
                            <i class="far fa-save"></i>
                          </button>-->
                          <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="field?.IsSelected"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                        </td>



                      </tr>
                      <!--<tr>
                        <td class="td-padding ">

                          <input type="checkbox" />
                          <i class="input-helper"></i>

                        </td>
                        <td>1</td>

                        <td>
                          <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" src="dummy.jpg" width="35px">
                        </td>
                        <td class="td-padding ">

                          new

                        </td>


                        <td class="text-align-right">
                          <button class="button-service-save font-size-20px color-secondary nav-link-hand" title="Save">
                            <i class="far fa-save"></i>
                          </button>
                          <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                        </td>



                      </tr>-->
                      <!--<tr>
                        <td class="td-padding ">

                          <input type="checkbox" />

                          <i class="input-helper"></i>

                        </td>

                        <td class="text-align-center">
                          B1
                        </td>
                        <td class="text-align-right">
                          <label>200</label>
                        </td>
                        <td class="td-padding ">
                          <input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                                 readonly
                                 min="1" max="10" />
                        </td>
                        <td class="td-padding ">
                          <input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                                 readonly
                                 min="1" max="10" />
                        </td>

                        <td class="text-align-right">
                          <a (click)="del_(l.ActorDocPageCode)" class="font-size-16px color-secondary nav-link-hand" title="Save"><i class="far fa-save"></i></a>
                          <a (click)="del_(l.ActorDocPageCode)" class="font-size-16px color-Rejected margin-left-17px nav-link-hand" title="Remove"><i class="far fa-trash-alt"></i></a>

                        </td>



                      </tr>-->
                    </tbody>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

 
